import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-details-pdc-actions',
  standalone: false,
  templateUrl: './details-pdc-actions.component.html',
  styleUrl: './details-pdc-actions.component.scss'
})
export class DetailsPdcActionsComponent {
  isLoading: boolean = false;
  searchTerm: string = '';
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  filteredtems: any = [];
  paginatedProjets = [];
  filteredProjetData: any[] = [];
  actionData: string = "";
  detailPdc: any = [];
  constructor(
    private paramService: ParameterService,
    private operationService: OperationService,
    private loader: NgxUiLoaderService,
    private localStorage: LocalStorageService,
        private modalService: NgbModal,
    
  ) { }

  ngOnInit() {
    this.actionData = this.localStorage.getDetailsPdcAction();

    this.getDetailPdcAction();
  }

  getDetailPdcAction() {
    this.paramService.getDetailPdcAction(this.actionData).subscribe(
      (response: any) => {
        this.isLoading = true;
        // this.detailPdc = response.data;
        // this.filteredtems = [...this.detailPdc];

        this.detailPdc = response.data.pdc_actions || []; 
        this.filteredtems = Array.isArray(this.detailPdc) ? [...this.detailPdc] : [];

        //console.log("la reposne du webservcie ", this.detailPdc);
        this.totalRecords = this.detailPdc.length;
        this.updatePaginatedProjets();
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);
        this.isLoading = false;

      }
    )
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  filterProjet() {
    
    const lowerSearchTerm = this.searchTerm.toLowerCase();

    if (!lowerSearchTerm) {
      this.filteredtems = [...this.detailPdc]; 
    } else {
      this.filteredtems = this.detailPdc.filter((item: any) => {
        const matchesCode = item.code && item.code.toLowerCase().includes(lowerSearchTerm);
        const matchesLibelle = item.libelle && item.libelle.toLowerCase().includes(lowerSearchTerm);

        return matchesCode || matchesLibelle 
      });
    }
    //console.log("azee");

    this.totalRecords = this.filteredtems.length;
    this.firstProjets = 0; // Reset to the first page
    this.updatePaginatedProjets();
  }
  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredtems.slice(start, end);
  }

  close(){
    this.modalService.dismissAll();
  }
}
